import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { TableInfractionsService } from './table-infractions.service';
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExtratoService } from '../extrato/extrato.service';
import { ToastrService } from "ngx-toastr";
import { saveAs } from 'file-saver';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { InfractionsService } from '../infractions/infractions.service';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';


@Component({
  selector: 'app-table-infractions',
  templateUrl: './table-infractions.component.html',
  styleUrls: ['./table-infractions.component.scss'],
  providers: [TableInfractionsService, DecimalPipe, DatePipe]
})
export class TableInfractionsComponent {
  @ViewChild('transactionDetailsModal')
  private transactionDetailsTpl!: TemplateRef<any>;
  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public transactionType: string = '';
  public selectedStatus: string = '';
  public selectedOrigin: string = '';
  public selectedApplciation: string = '';
  public selectedWebhookStatus: string = '';
  public personName: string = '';
  public searchType: string = '';
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;
  public receiptTemplate: string = '';
  public nameColumn: string = '';
  public account: any;
  public transactions: Array<any> = [];
  public selectedTransaction: any;
  public selectedCrypto: any = null;
  public canDownloadReceipt = false;
  public canResendWebhook = false;
  public isReprocessing = false;
  public tableRowForReceipt: any = null;
  public startDateIso?: string;
  public endDateIso?: string;
  public pad(n: number) { return String(n).padStart(2, '0'); }
  langChangeSub!: Subscription;

  constructor(private infractionsService: InfractionsService,
    private tableInfractionsService: TableInfractionsService,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private translate: TranslateService,
    private modal: NgbModal,
    private datePipe: DatePipe,
    private decimal: DecimalPipe) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    this.selectedStatus = 'REALIZADO';
  }

  isValidPixDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-02-05T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  isValidTefDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-05-02T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  public getTransactions() {
    let dateInitialFormat: string;
    let dateFinalFormat: string;

    if (this.startDateIso && this.endDateIso) {
      dateInitialFormat = this.startDateIso;
      dateFinalFormat = this.endDateIso;
    } else {
      const y1 = this.dataInitial.year, m1 = this.pad(this.dataInitial.month), d1 = this.pad(this.dataInitial.day);
      const y2 = this.dataFinal.year, m2 = this.pad(this.dataFinal.month), d2 = this.pad(this.dataFinal.day);
      dateInitialFormat = `${y1}-${m1}-${d1}T00:00:00`;
      dateFinalFormat = `${y2}-${m2}-${d2}T23:59:59`;
    }

    this.infractionsService.getTransactionsExtrato(
      dateInitialFormat,
      dateFinalFormat,
      this.transactionType,
      this.selectedStatus,
      this.personName,
      this.page,
      this.pageSize,
      this.searchType
    ).subscribe(value => {
      this.transactions = value.medPix;
      this.total = value.total;
    });
  }

  fmtDate(d: string) { return this.datePipe.transform(d, 'dd/MM/yyyy HH:mm:ss', 'UTC'); }
  fmtMoney(v: number) { return this.decimal.transform(v, '1.2-2', 'pt-BR'); }

  formatStatusClass(status: string): string {
    return 'status-' + status.toLowerCase().replace(/ /g, '-');
  }

  pageChange() {
    this.getTransactions();
  }

  async resendWebhook(transaction: any) {
    if (this.isReprocessing) { return; }
    this.isReprocessing = true;

    this.toastr.info('Reenviando webhook…', '', { timeOut: 2000 });

    try {
      await this.tableInfractionsService.resendWebhook([transaction.id]);
      this.toastr.success('Webhook reenviado com sucesso');
    } catch {
      this.toastr.error('Falha ao reenviar webhook');
    } finally {
      this.isReprocessing = false;
    }
  }

  webhookTooltip(tx: any): string {
    const val = (tx?.userNotificationWebHook ?? '').toString().trim();
    return `Notificação Webhook: ${val || '-'}`;
  }

  isApiOrTef(tx: any): boolean {
    const app = (tx?.aplicacao || tx?.application || '').toString().toUpperCase();
    return app === 'API' || app === 'TEF';
  }

  isWebOrTefWeb(tx: any): boolean {
    const app = (tx?.aplicacao || tx?.application || '').toString().toUpperCase();
    return app === 'WEB' || app === 'TEFWEB';
  }

  hasWebhookValue(tx: any): boolean {
    const v = tx?.userNotificationWebHook;
    return typeof v === 'string' && v.trim().length > 0;
  }


  async downloadReceipt(rowFromGrid: any) {
    this.toastr.info('Gerando comprovante…', '', {
      timeOut: 2000, positionClass: 'toast-top-right',
    });

    try {
      const payload = rowFromGrid;

      const response = await firstValueFrom(this.pdfService.reportWithdraw(payload));
      const bytes = atob(response);
      const buf = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);

      saveAs(new Blob([buf], { type: 'application/pdf' }), 'comprovante.pdf');

      this.toastr.success('Comprovante gerado com sucesso!', 'Sucesso', {
        timeOut: 3000, positionClass: 'toast-top-right',
      });
    } catch (err: any) {
      const msg = err?.error?.mensagem || err?.message || 'Falha ao gerar comprovante.';
      this.toastr.error(msg, 'Erro', {
        timeOut: 3000, positionClass: 'toast-top-right',
      });
    }
  }
}


